import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import { ApiService } from './api.service';

export type NotificationChannelMode = 'TelegramOnly' | 'SmsOnly' | 'Hybrid';

export interface SystemSettingsDto {
  notificationChannelMode: NotificationChannelMode;
}

/**
 * OTP va tizim xabarlari qaysi kanal(lar) orqali ketishini boshqaradi —
 * butun platforma uchun bitta sozlama (SuperAdmin).
 */
@Injectable({ providedIn: 'root' })
export class NotificationSettingsService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/SuperAdmin/system-settings`;

  get(): Observable<ApiResponse<SystemSettingsDto>> {
    return this.http.get<ApiResponse<SystemSettingsDto>>(this.endpoint);
  }

  update(mode: NotificationChannelMode): Observable<ApiResponse<SystemSettingsDto>> {
    return this.http.put<ApiResponse<SystemSettingsDto>>(this.endpoint, {
      notificationChannelMode: mode,
    });
  }
}
